import { c as _c } from "react/compiler-runtime";
import { useFetchLivePlayMutationStore } from '@module/stores/useFetchLivePlayMutationStore';
import { MODAL_TYPE_PC } from '@module/types/modal/type';
import { checkIsMobile } from '@module/utils/checkIsMobile';
import Cookies from 'js-cookie';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import useModalStore from '../../stores/useModalStore';
import TimeConstants from '../../utils/item';
import useGetLoginInfoQuery from '../auth/useGetLoginInfoQuery';
import { aspCond } from '../conditions/condition';

/**
 * 특정 사이트 조건의 시청화면에서 로그인, 본인인증 강요하는 인터벌 훅
 */
function useForceAuthInterval() {
  const $ = _c(12);
  const router = useRouter();
  const {
    modal,
    pushModal,
    popModal
  } = useModalStore();
  const {
    isLogin,
    isAdult
  } = useGetLoginInfoQuery();
  const playInfo = useFetchLivePlayMutationStore(_temp);
  const isAdultContent = playInfo?.media.isAdult;
  let t0;
  if ($[0] !== isAdult || $[1] !== isAdultContent || $[2] !== isLogin || $[3] !== modal || $[4] !== popModal || $[5] !== pushModal || $[6] !== router) {
    t0 = () => {
      if (aspCond.if("asp")) {
        return;
      }
      const forceAuthInterval = setInterval(() => {
        if (modal.length > 0) {
          return;
        }
        if (isLogin && isAdultContent && !isAdult) {
          pushModal({
            type: "CONFIRM_CANCEL_MODAL",
            id: "useForceAuthInterval",
            options: {
              description: "\uBCF8\uC778\uC778\uC99D \uD6C4 \uB354 \uB2E4\uC591\uD55C \uCF58\uD150\uCE20\uB97C \uB9CC\uB098\uBCF4\uC138\uC694.",
              onClick: () => {
                popModal();
                if (checkIsMobile()) {
                  router.push("/my/auth");
                } else {
                  pushModal({
                    id: "useForceAuthInterval",
                    type: MODAL_TYPE_PC.IDENTITY_VERIFICATION_MODAL
                  });
                }
              }
            }
          });
          return;
        }
        if (isLogin) {
          return;
        }
        const isUldPLogin = Cookies.get("uld_pLogin") === "Y";
        const isSLMode = new URLSearchParams(window.location.search).get("sl") === "1";
        if (isAdultContent || isUldPLogin || isSLMode) {
          pushModal({
            type: "AUTH_MODAL",
            id: "useForceAuthInterval"
          });
          return;
        }
        clearInterval(forceAuthInterval);
      }, TimeConstants.ONE_SECOND * 5);
      return () => {
        clearInterval(forceAuthInterval);
      };
    };
    $[0] = isAdult;
    $[1] = isAdultContent;
    $[2] = isLogin;
    $[3] = modal;
    $[4] = popModal;
    $[5] = pushModal;
    $[6] = router;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  let t1;
  if ($[8] !== isAdultContent || $[9] !== isLogin || $[10] !== modal) {
    t1 = [isAdultContent, modal, isLogin];
    $[8] = isAdultContent;
    $[9] = isLogin;
    $[10] = modal;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  useEffect(t0, t1);
}
function _temp(state) {
  return state.data;
}
export default useForceAuthInterval;